<template>
  <div style="position: relative">
    <editor-item
      v-for="element of content"
      :key="element.uid"
      :value="element"
      @loaded="$emit('loaded', $event)"
      @loading="$emit('loading', $event)"
    />
  </div>
</template>
<script>
export default {
  name: 'Editor',
  props: {
    content: {
      type: Array,
      required: true
    }
  }
};
</script>
